var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_4518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 2.29346C5.40033 2.29346 1.66699 6.0739 1.66699 10.7319C1.66699 15.39 5.40033 19.1704 10.0003 19.1704C14.6003 19.1704 18.3337 15.39 18.3337 10.7319C18.3337 6.0739 14.6003 2.29346 10.0003 2.29346ZM5.89199 16.0313C6.25033 15.2718 8.43366 14.5293 10.0003 14.5293C11.567 14.5293 13.7587 15.2718 14.1087 16.0313C12.9753 16.9427 11.5503 17.4827 10.0003 17.4827C8.45033 17.4827 7.02533 16.9427 5.89199 16.0313ZM15.3003 14.8077C14.1087 13.3394 11.217 12.8416 10.0003 12.8416C8.78366 12.8416 5.89199 13.3394 4.70033 14.8077C3.85033 13.677 3.33366 12.2677 3.33366 10.7319C3.33366 7.01057 6.32533 3.98115 10.0003 3.98115C13.6753 3.98115 16.667 7.01057 16.667 10.7319C16.667 12.2677 16.1503 13.677 15.3003 14.8077ZM10.0003 5.66885C8.38366 5.66885 7.08366 6.98526 7.08366 8.62232C7.08366 10.2594 8.38366 11.5758 10.0003 11.5758C11.617 11.5758 12.917 10.2594 12.917 8.62232C12.917 6.98526 11.617 5.66885 10.0003 5.66885ZM10.0003 9.88809C9.30866 9.88809 8.75033 9.32272 8.75033 8.62232C8.75033 7.92193 9.30866 7.35655 10.0003 7.35655C10.692 7.35655 11.2503 7.92193 11.2503 8.62232C11.2503 9.32272 10.692 9.88809 10.0003 9.88809Z",
    fill: "#3C3C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_4518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.2524,
    fill: "white",
    transform: "translate(0 0.605713)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ea9aa2b43758d7c480624185f1cb5b5c.svg";
export { ForwardRef as ReactComponent };